<template>
  <div class="publicMain">
    <div class="mianbao">
      <!--  -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>档案管理</el-breadcrumb-item>
        <el-breadcrumb-item>老人档案</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 模糊查询 -->
    <div class="childrenFileSelect">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="form.sex">
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="form.idCode"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onCheck">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
        <el-table-column
          v-for="(item,index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <div v-if="item.type=='button'">
              <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                <button class="iconfont icon-bianji3 tabBtn" @click="compile(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>
              </el-tooltip>
              <!-- <el-tooltip class="item" effect="light" content="审批" placement="top-start">
                <button class="iconfont icon-tongguos tabBtn" @click="audit(scope.row)"></button>
              </el-tooltip>-->
            </div>
            <div v-else-if="item.type=='state'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row.state==1">待审核</el-tag>
                <el-tag v-if="scope.row.state==2" type="success">通过</el-tag>
                <el-tag v-if="scope.row.state==3" type="danger">不通过</el-tag>
              </div>
            </div>
            <div v-else-if="item.type=='sex'">
              <div style="text-align:center;">
                <span v-if="scope.row.sex==1" type="success">男</span>
                <span v-if="scope.row.sex==0" type="primary">女</span>
              </div>
            </div>
            <div v-else-if="item.type=='nature'">
              <div style="text-align:center;">
                <el-tag v-if="scope.row.nature==1" type="success">农村户口</el-tag>
                <el-tag v-if="scope.row.nature==2" type="warning">城镇户口</el-tag>
                <el-tag v-if="scope.row.nature==3" type="danger">无户口</el-tag>
              </div>
            </div>
            <div
              v-else
              :style="{'text-align':item.align?item.align:'center'}"
            >{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {

  oldManFileList,
  oldManFileDelete
} from "./api";

export default {
  components: {},
  data() {
    return {
      title: "查看", //el-dialog标题
      visible: false, //el-dialog现在
      activeName: "first", //el-tabs切换的
      currentPage: 1, //默认展示第一页
      //模糊查询数据
      form: {},
      //table表格的column
      tableColumn: [
        {
          prop: "name",
          label: "姓名"
        },
        {
          type: "sex",
          prop: "sex",
          label: "性别"
        },
        {
          prop: "age",
          label: "年龄"
        },
        {
          prop: "phone",
          label: "联系电话"
        },
        {
          prop: "idCode",
          label: "身份证号"
        },
        {
          label: "操作",
          type: "button"
        }
      ],
      //table表格的数据
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0, //每页总书记
      buttonType: "", //代表不同button的按钮类别
      row: {}, //按钮当前选中行的数据
      helpTypeManageShow: false, //
      helpAddShow: false, //
      helpAuditShow: false, //审核的现实隐藏
      queryData: {} //
    };
  },
  methods: {
    //模糊查询
    onCheck() {
      this.provideManageAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form
      });
    },
    //模糊查询的重置
    onReset() {
      this.form = {};
      this.pageNo = 1;
      this.pageSize = 10;
      this.provideManageAPI();
    },
    //分页选择每页的数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.provideManageAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //分页选择不同页的数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.provideManageAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },
    //拿到列表
    provideManageAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      oldManFileList(params).then(res => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //查看
    check(e) {
      this.$router.push({
        path: "/addOldManFile",
        query: {
          id:e.id,
          row: JSON.stringify(e),
          buttonType: "check"
        }
      });
    },
    //编辑
    compile(e) {
      this.$router.push({
        path: "/addOldManFile",
        query: {
          id:e.id,
          row: JSON.stringify(e),
          buttonType: "compile"
        }
      });
    },
    //删除
    remove(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          oldManFileDelete({ id: e.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.provideManageAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },
  created() {
    this.provideManageAPI();
  }
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  margin-top: 20px;
}
.table {
  margin-top: 40px;
}
.button1 {
  width: 400px;
  margin: 30px auto 0px;
  display: flex;
  justify-content: space-between;
}
.childrenFileSelect {
  border: 1px solid rgb(230, 230, 230);
  padding: 20px;
}
.add {
  padding: 20px 0px;
}
.icon-icon7 {
  color: #dd3020;
}
.icon-tongguos {
  color: #0d5795;
}
.pagination {
  margin-top: 10px;
}
</style>
